module.exports = __webpack_public_path__ + "img/bg_dsbiz.f8c6eacd.png";